import React, { Fragment, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { loginReq } from "./fetchApi";
import { LayoutContext } from "../index";
import { useSnackbar } from 'notistack';
import GoogleAuth from './GoogleAuth';

const Login = (props) => {
  const { data: layoutData, dispatch: layoutDispatch } = useContext(
    LayoutContext
  );
  const history = useHistory();
  const [data, setData] = useState({
    email: "",
    password: "",
    error: false,
    loading: true,
  });

  const alert = (msg) => <div className="text-xs text-red-600">{msg}</div>;

  const { enqueueSnackbar } = useSnackbar();

  const formSubmit = async () => {
    

    setData({ ...data, loading: true });
    try {
      let responseData = await loginReq({
        email: data.email,
        password: data.password,
      });
      if (responseData.error) {
        setData({
          ...data,
          loading: false,
          error: responseData.error,
          password: "",
        });
      } else if (responseData.token) {
        setData({ email: "", password: "", loading: false, error: false });
        localStorage.setItem("jwt", JSON.stringify(responseData));
        localStorage.setItem("userId", responseData.user._id);
       enqueueSnackbar('Connexion réussie !', { variant: 'success' })
       // Ferme le modal
     
  layoutDispatch({ type: "loginSignupModalToggle", payload: false });

  // Redirige vers l'accueil
  history.push("/");

      }    
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Fragment>
  <div className="text-center text-2xl font-semibold text-blue-800 mb-6">Se connecter</div>
      {layoutData.loginSignupError ? (
        <div className="bg-red-200 py-2 px-4 rounded">
          Vous devez vous connecter pour passer à la caisse. Vous n’avez pas de compte ? Créez-en un nouveau.
        </div>
      ) : (
        ""
      )}
      <form className="space-y-4">
        <div className="flex flex-col">
          <label htmlFor="name">
          Nom d’utilisateur ou adresse e-mail
            <span className="text-sm text-gray-600 ml-1">*</span>
          </label>
          <input
            onChange={(e) => {
              setData({ ...data, email: e.target.value, error: false });
              layoutDispatch({ type: "loginSignupError", payload: false });
            }}
            value={data.email}
            type="text"
            id="name"
            className={`${!data.error ? "" : "border-red-500"} px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 border-gray-300`}
          />
          {!data.error ? "" : alert(data.error)}
        </div>
        <div className="flex flex-col">
          <label htmlFor="password">
          Mot de passe<span className="text-sm text-gray-600 ml-1">*</span>
          </label>
          <input
            onChange={(e) => {
              setData({ ...data, password: e.target.value, error: false });
              layoutDispatch({ type: "loginSignupError", payload: false });
            }}
            value={data.password}
            type="password"
            id="password"
            className={`${!data.error ? "" : "border-red-500"} px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 border-gray-300`}
          />
          {!data.error ? "" : alert(data.error)}
        </div>
        <div className="flex flex-col space-y-2 md:flex-row md:justify-between md:items-center">
          <div>
            <input
              type="checkbox"
              id="rememberMe"
              className="px-4 py-2 focus:outline-none border mr-1 rounded"
            />
            <label htmlFor="rememberMe">
            Se souvenir de moi<span className="text-sm text-gray-600">*</span>
            </label>
          </div>
          
        </div>
        <div
          onClick={(e) => formSubmit()}
          // style={{ background: "#1E344D" }}
          className="w-full font-medium px-4 py-2 text-white bg-blue-800 hover:bg-blue-700 active:bg-blue-900 transition rounded-lg text-center cursor-pointer"
        >
         Connexion
        </div>

        {/* Divider */}
        <div className="flex items-center gap-3 my-4">
          <div className="flex-1 h-px bg-gray-300"></div>
          <span className="text-sm text-gray-500 font-medium">OU</span>
          <div className="flex-1 h-px bg-gray-300"></div>
        </div>

        {/* Google Sign In */}
        <GoogleAuth />
      </form>
    </Fragment>
  );
};

export default Login;
